module.exports = __webpack_public_path__ + "media/flags/ml-0ef5116b.svg";